module.exports = __webpack_public_path__ + "media/application/images/ui/icon-instagram-341129a189a93e23c98a2e7945879e42.png";